(function () {
  'use strict';

  var OLD_PHONE = /(?:\+?1[\s().-]*)?\(?613\)?[\s().-]*255[\s.-]*2702/g;
  var NEW_PHONE = '613-400-4588';
  var NEW_PHONE_LINK = 'tel:+16134004588';
  var OLD_ACCESSORIES = '/collections/accessories-1';
  var NEW_ACCESSORIES = '/collections/formuler-dreamlink-accessories';
  var OLD_STOCK_TEXT = 'The brand has stopped making new boxes and we only have remaining Dlite+ 5G stock';
  var NEW_STOCK_TEXT = 'New Dreamlink receivers are discontinued, while selected open-box units and replacement parts remain available';
  var running = false;

  function normalizeText(text) {
    return (text || '')
      .replace(OLD_PHONE, NEW_PHONE)
      .replace(OLD_STOCK_TEXT, NEW_STOCK_TEXT);
  }

  function cleanTextNodes(root) {
    var scope = root && root.nodeType === 1 ? root : document;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null, false);
    var node;

    while ((node = walker.nextNode())) {
      var parent = node.parentElement;
      var current;
      var updated;

      if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(parent.tagName)) {
        continue;
      }

      current = node.nodeValue || '';
      updated = normalizeText(current);
      if (updated !== current) {
        node.nodeValue = updated;
      }
    }
  }

  // Include the root itself when an app inserts or changes a single matching element.
  function selectWithin(root, selector) {
    var scope = root && root.querySelectorAll ? root : document;
    var matches = Array.prototype.slice.call(scope.querySelectorAll(selector));
    if (scope.nodeType === 1 && scope.matches && scope.matches(selector)) {
      matches.unshift(scope);
    }
    return matches;
  }

  function cleanLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;

    selectWithin(scope, 'a[href]').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      var digits;
      var suffix;

      if (href.indexOf('tel:') === 0) {
        digits = href.replace(/\D/g, '');
        if (digits.slice(-10) === '6132552702') {
          link.setAttribute('href', NEW_PHONE_LINK);
        }
      }

      if (href.indexOf(OLD_ACCESSORIES) === 0) {
        suffix = href.slice(OLD_ACCESSORIES.length);
        link.setAttribute('href', NEW_ACCESSORIES + suffix);
      } else if (/^https?:\/\/(?:www\.)?dreamlinkstore\.com\/collections\/accessories-1/i.test(href)) {
        suffix = href.replace(/^https?:\/\/(?:www\.)?dreamlinkstore\.com\/collections\/accessories-1/i, '');
        link.setAttribute('href', 'https://dreamlinkstore.com' + NEW_ACCESSORIES + suffix);
      }

      if (/^http:\/\/(?:www\.)?formulerstore\.com/i.test(href)) {
        link.setAttribute('href', href.replace(/^http:\/\/(?:www\.)?formulerstore\.com/i, 'https://www.formulerstore.com'));
      }
    });
  }

  function invalidSavings(label) {
    var text = (label.textContent || '').replace(/\s+/g, ' ').trim();
    return /(?:save|economisez|économisez|ahorra|spare|risparmia).*[-−–]\s*(?:[$€£]\s*)?\d/i.test(text) ||
      /(?:[$€£]\s*)[-−–]\s*\d/.test(text);
  }

  function cleanSaleLabels(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var labels = [];

    if (root && root.nodeType === 1 && root.matches && root.matches('.product-label--on-sale')) {
      labels.push(root);
    }
    labels = labels.concat(Array.prototype.slice.call(scope.querySelectorAll('.product-label--on-sale')));
    labels.forEach(function (label) {
      if (label.parentNode && invalidSavings(label)) {
        label.parentNode.removeChild(label);
      }
    });
  }

  function cleanRefundLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;

    selectWithin(scope, '.product__refund-policy-link').forEach(function (button) {
      var link;
      if (button.tagName === 'A' && button.getAttribute('href') === '/pages/refund-policy') {
        return;
      }
      if (!button.parentNode) {
        return;
      }
      link = document.createElement('a');
      link.className = button.className;
      link.href = '/pages/refund-policy';
      link.textContent = 'Return & Refund Policy';
      button.parentNode.replaceChild(link, button);
    });

    var modal = document.getElementById('modal-refunds-policy');
    if (modal && modal.parentNode) {
      modal.parentNode.removeChild(modal);
    }
  }

  function scrubJson(value) {
    var key;

    if (Array.isArray(value)) {
      return value.filter(function (item) {
        return !(typeof item === 'string' && /^https?:\/\/(?:www\.)?formuler\.vip\/?$/i.test(item));
      }).map(scrubJson);
    }

    if (value && typeof value === 'object') {
      for (key in value) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
          if (key === 'telephone' && typeof value[key] === 'string') {
            value[key] = value[key].replace(OLD_PHONE, '+1-613-400-4588');
          } else {
            value[key] = scrubJson(value[key]);
          }
        }
      }
      return value;
    }

    if (typeof value === 'string') {
      return normalizeText(value)
        .replace(OLD_ACCESSORIES, NEW_ACCESSORIES)
        .replace(/^http:\/\/(?:www\.)?formulerstore\.com/i, 'https://www.formulerstore.com');
    }

    return value;
  }

  function cleanStructuredData(root) {
    selectWithin(root, 'script[type="application/ld+json"]').forEach(function (script) {
      var before = script.textContent || '';
      var data;
      var after;
      try {
        data = JSON.parse(before);
        after = JSON.stringify(scrubJson(data));
        if (after !== before) {
          script.textContent = after;
        }
      } catch (error) {
        return;
      }
    });
  }

  function moveCollectionGuide() {
    var targets = ['/collections/formuler-new', '/collections/dreamlink-new', '/collections/open-box-new'];
    var path = window.location.pathname.replace(/\/$/, '');
    var description;
    var container;
    var header;
    var firstParagraph;
    var intro;
    var style;

    if (targets.indexOf(path) === -1) {
      return;
    }

    description = document.querySelector('.collection__description');
    container = document.querySelector('.collection');
    header = document.querySelector('.collection__header-inner');

    if (!description || !container || !header || description.getAttribute('data-seo-moved') === 'true') {
      return;
    }

    firstParagraph = description.querySelector('.rte > p:first-child');
    if (firstParagraph) {
      intro = document.createElement('div');
      intro.className = 'collection__intro rte';
      intro.appendChild(firstParagraph.cloneNode(true));
      header.appendChild(intro);
      firstParagraph.parentNode.removeChild(firstParagraph);
    }

    description.setAttribute('data-seo-moved', 'true');
    description.setAttribute('aria-expanded', 'true');
    description.classList.add('collection__description--below-products');
    container.appendChild(description);

    if (!document.getElementById('collection-seo-layout-styles')) {
      style = document.createElement('style');
      style.id = 'collection-seo-layout-styles';
      style.textContent = '.collection__intro{margin-top:12px}.collection__description--below-products{margin-top:32px;padding:28px;background:var(--secondary-background);border-top:1px solid var(--border-color)}@media(max-width:640px){.collection__description--below-products{margin-top:22px;padding:22px 18px}}';
      document.head.appendChild(style);
    }
  }

  function clean(root) {
    if (running) {
      return;
    }
    running = true;
    try {
      cleanTextNodes(root);
      cleanLinks(root);
      cleanSaleLabels(root);
      cleanRefundLinks(root);
      cleanStructuredData(root);
    } finally {
      running = false;
    }
  }

  function run() {
    clean(document);
    moveCollectionGuide();
  }

  function start() {
    var observer;
    run();
    window.setTimeout(run, 500);

    // Coalesce each burst and inspect changed subtrees instead of repeatedly scanning the page.
    var pendingRoots = [];
    var flushTimer = null;

    function flushPending() {
      var roots = pendingRoots;
      pendingRoots = [];
      flushTimer = null;
      roots.forEach(function (root) {
        if (document.documentElement.contains(root)) {
          clean(root);
        }
      });
    }

    function queueRoot(root) {
      if (!root || root.nodeType !== 1 || !document.documentElement.contains(root)) {
        return;
      }
      if (/^(STYLE|NOSCRIPT|TEXTAREA)$/.test(root.tagName) ||
          (root.tagName === 'SCRIPT' && root.type !== 'application/ld+json')) {
        return;
      }
      if (pendingRoots.some(function (existing) { return existing.contains(root); })) {
        return;
      }
      pendingRoots = pendingRoots.filter(function (existing) { return !root.contains(existing); });
      pendingRoots.push(root);
      if (flushTimer === null) {
        flushTimer = window.setTimeout(flushPending, 0);
      }
    }

    observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'characterData') {
          queueRoot(record.target.parentElement);
        } else if (record.type === 'attributes') {
          queueRoot(record.target);
        } else {
          Array.prototype.forEach.call(record.addedNodes, function (node) {
            queueRoot(node.nodeType === 1 ? node : node.parentElement);
          });
        }
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['href']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());
